import React from "react";
import "./App.css";
// import Navbar from './components/Navbar';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "../src/screens/Home/index";
import Launch from "../src/screens/Launch/index";
function App() {
  return (
    <Router>
      {/* <Navbar /> */}
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/Home" exact component={Home} />
        {/* <Route path="/about" component={About} />
        <Route path="/contact" component={Contact} />
        <Route path="/quote" component={Quota} />
        <Route path="/Work" component={Work} /> */}
        <Route path="/Launch" component={Launch} />
      </Switch>
    </Router>
  );
}

export default App;
